import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Typography from '@material-ui/core/Typography';
import TextField from '../forms/text-field';
import CheckboxField from '../forms/checkbox-field';

const EventFormLocation = ({ disabled, forceTouched }) => {
  const {
    values: { eventType, loop },
  } = useFormikContext();

  if (eventType === 'ONLINE_EVENT') {
    return null;
  }

  return (
    <Fragment>
      <Typography variant="h2">Location</Typography>
      {eventType === 'RIDE' && <Typography variant="h3">Start</Typography>}
      <TextField
        name="startLocation"
        label={`${eventType === 'RIDE' ? 'Start ' : ''}Location Name`}
        disabled={disabled}
        touched={forceTouched}
      />
      <TextField
        name="startLocationAddress"
        label={`${eventType === 'RIDE' ? 'Start ' : ''}Location Address (optional)`}
        disabled={disabled}
        touched={forceTouched}
      />
      <TextField
        name="startLocationDetails"
        label={`${eventType === 'RIDE' ? 'Start ' : ''}Location Details (optional)`}
        helperText=""
        disabled={disabled}
        touched={forceTouched}
      />
      {eventType === 'RIDE' && (
        <Fragment>
          <Typography variant="h3">End</Typography>
          <CheckboxField
            name="loop"
            label="Loop"
            helperText="If the ride start and ends at the same location"
            disabled={disabled}
            touched={forceTouched}
          />
          {!loop && (
            <Fragment>
              <TextField
                name="endLocation"
                label="End Location Name (optional)"
                disabled={disabled}
                touched={forceTouched}
              />
              <TextField
                name="endLocationAddress"
                label="End Location Address (optional)"
                disabled={disabled}
                touched={forceTouched}
              />
              <TextField
                name="endLocationDetails"
                label="End Location Details (optional)"
                helperText=""
                disabled={disabled}
                touched={forceTouched}
              />
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

EventFormLocation.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormLocation;
